import { DeviceType } from "@/services/ContentsService";
import ArmDeviceIcon from "@/v2-components/core/icon/ArmDeviceIcon";
import FootDeviceIcon from "@/v2-components/core/icon/FootDeviceIcon";
import GloveDeviceIcon from "@/v2-components/core/icon/GloveDeviceIcon";
import HandDeviceIcon from "@/v2-components/core/icon/HandDeviceIcon";
import HeadDeviceIcon from "@/v2-components/core/icon/HeadDeviceIcon";
import MetaIcon from "@/v2-components/core/icon/meta-icon";
import OculusIcon from "@/v2-components/core/icon/oculus-icon";
import PCPlatformIcon from "@/v2-components/core/icon/pc-platform-icon";
import PSVRIcon from "@/v2-components/core/icon/ps-vr-icon";
import SimRacingIcon from "@/v2-components/core/icon/sim-racing-icon";
import PicoIcon from "@/v2-components/core/icon/PicoIcon";
import SteamIcon from "@/v2-components/core/icon/steam-icon";
import ViveIcon from "@/v2-components/core/icon/vive-icon";
import VestDeviceIcon from "@/v2-components/core/icon/VestDeviceIcon";

/**
 * **facet 값**(`quest`)으로 키를 잡는다. `GameCard.tsx` 에도 같은 이름의 맵이 있는데
 * 그건 **친화명**(`Meta Quest`)으로 키를 잡는다 — 쓰임이 달라서 둘 다 필요하다
 * (여기는 필터 UI, 저기는 카드의 플랫폼 칩).
 *
 * ⚠️ 그래서 **한쪽에만 플랫폼을 추가하면 다른 쪽에서 아이콘이 조용히 사라진다.**
 * 실제로 `vive` 가 그랬다 — `GameCard` 에는 `VIVE: ViveIcon` 이 있는데 여기엔 없어서
 * 필터에서만 아이콘이 없었다. `__tests__/v2-components/platform-icon-maps.test.ts` 가
 * 두 맵의 플랫폼 집합을 대조한다.
 */
const PLATFORM_ICONS = {
  steam: SteamIcon,
  quest: MetaIcon,
  rift: OculusIcon,
  vive: ViveIcon,
  psvr2: PSVRIcon,
  pico: PicoIcon,
  pc: PCPlatformIcon,
  simracing: SimRacingIcon,
};

export const getFilterIcon = (value: string) => {
  switch (value) {
    case DeviceType.Arm:
      return ArmDeviceIcon;
    case DeviceType.Foot:
      return FootDeviceIcon;
    case DeviceType.Glove:
      return GloveDeviceIcon;
    case DeviceType.Hand:
      return HandDeviceIcon;
    case DeviceType.Head:
      return HeadDeviceIcon;
    case DeviceType.Vest:
      return VestDeviceIcon;
    default:
      return PLATFORM_ICONS[value] ?? null;
  }
};
